<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>تائید رمز موقت</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-alert type="error" v-if="showMessage" icon="fa-times">
                رمز موقت نادرست است.
              </v-alert>
              <v-text-field
                id="tac"
                label="رمز موقت"
                name="tac"
                prepend-icon="fa-sms"
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="tac"
                :rules="tacRules"
                clearable
                required
              />
            </v-form>
          </v-card-text>
          <v-card-text>
            رمز موقت به شماره 09131970628 ارسال شد. 300 ثانیه دیگر می‌توانید
            دوباره تلاش کنید.
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="primary" @click="SubmitForm">
                  <v-icon class="ml-1">fa-check-double</v-icon>تائید
                </v-btn>
              </v-col>
              <v-col class="text-sm-left">
                <v-btn :to="{ name: 'Login' }">
                  <v-icon class="ml-1">fa-sign-out-alt</v-icon>خروج
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Confirm",
  data: () => ({
    showMessage: false,
    showPassword: false,
    tac: "",
    tacRules: [
      v => !!v || "ورود رمز موقت الزامی است",
      v => (!!v && v.length === 6) || "حداقل طول رمز موقت 6 کاراکتر است"
    ]
  }),
  methods: {
    SubmitForm() {
      if (this.tac === "111111") {
        this.showMessage = true;
      } else {
        this.$router.push({ name: "Dashboard" });
      }
    }
  }
};
</script>
